import { combineReducers } from "@reduxjs/toolkit";
import { basicInformationTableReducer } from "@/widgets/basic-information/BasicInformationTable/slice";
import { printVolumeChart } from "@/widgets/print-volume/PrintVolumeChart/state";
import { printVolumeHorizontalChart } from "@/widgets/print-volume/PrintVolumeHorizontalChart/state";
import { inkTrendChart } from "@/widgets/ink/InkTrendChart/state";
import { oeeTrendChart } from "@/widgets/oee/OeeTrendChart/state";
import { runningStatusChart } from "@/widgets/machine/RunningStatusChart/state";
import { runningStatusShareChart } from "@/widgets/machine/RunningStatusShareChart/state";
import { averageRatePie } from "@/widgets/machine/AverageRatePie/state";
import { paperUsage } from "@/widgets/paper-usage/PaperUsage/state";
import { printedColorUsage } from "@/widgets/paper-usage/PrintedColorUsage/state";
import { printOverviewReducer } from "@/widgets/print-overview/state";
import { serialList } from "@/widgets/common/serialList/state";
import { chartLegendReducer } from "./chartLegendSlice";
import { localeReducer } from "./localeSlice";
import { serialFilterReducer } from "./serialFilterSlice";

/**
 * Registers widget reducers (convention section 16.3). Factory-based widgets
 * (D11) expose `{ name, reducer }` from their `state.ts`; the paging table
 * widget keeps its hand-written slice (see its types.ts for why).
 */
export const rootReducer = combineReducers({
  basicInformationTable: basicInformationTableReducer,
  printVolumeChart: printVolumeChart.reducer,
  printVolumeHorizontalChart: printVolumeHorizontalChart.reducer,
  inkTrendChart: inkTrendChart.reducer,
  oeeTrendChart: oeeTrendChart.reducer,
  runningStatusChart: runningStatusChart.reducer,
  runningStatusShareChart: runningStatusShareChart.reducer,
  averageRatePie: averageRatePie.reducer,
  paperUsage: paperUsage.reducer,
  printedColorUsage: printedColorUsage.reducer,
  // Print Overview page: per-granularity point caches feeding both charts
  // + the KPI cards (a level's refetch never wipes the sibling's level).
  printOverview: printOverviewReducer,
  // App-wide reference data (machine serial list): one shared slice every
  // page reads via `useSerialList` — fetched once per session (main.tsx).
  serialList: serialList.reducer,
  // App-level UI persistence (FR-A8 user settings): chart legend on/off maps.
  chartLegend: chartLegendReducer,
  // App-level locale (FR-A8 user settings): language for UI strings and
  // number formatting (shared/i18n + Intl).
  locale: localeReducer,
  // App-level serial filter (FR serial filter): the UNCHECKED serial mpKeys —
  // default empty, i.e. every serial checked.
  serialFilter: serialFilterReducer,
});
